import { useState, useEffect } from 'react';
import { fetchWithRetry } from '../../utils/fetchWithRetry';
import { RELEASES_CONFIG } from './releases';

// The channel's binaries.json as {version, platforms, loading, error}.
// Refetches when the channel changes; a response for a channel the user
// has already switched away from is dropped.
export function useReleaseInfo(channel) {
  const [info, setInfo] = useState({ version: null, platforms: null, loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    const baseUrl = RELEASES_CONFIG[channel].baseUrl;
    setInfo(prev => ({ ...prev, loading: true, error: null }));

    (async () => {
      try {
        const res = await fetchWithRetry(`${baseUrl}/binaries.json`);
        if (!res.ok) throw new Error(`binaries.json ${res.status}`);
        const data = await res.json();
        if (cancelled) return;
        setInfo({
          version: data.version || null,
          platforms: data.platforms || null,
          loading: false,
          error: null,
        });
      } catch (err) {
        if (cancelled) return;
        setInfo({ version: null, platforms: null, loading: false, error: 'Failed to fetch release info' });
      }
    })();

    return () => { cancelled = true; };
  }, [channel]);

  return info;
}
